"use strict";

var cx = require("classnames");

var UploadProgress = React.createClass({
  getDefaultProps: function () {
    return {
      uploadState: "starting",
      progress: 0
    };
  },
  getLoaderBarStyle: function () {
    if (this.props.uploadState == "started") {
      return {
        width: this.props.progress + "%"
      };
    } else {
      return {};
    }
  },
  getLoaderClasses: function () {
    var classes = cx({
      "uploadLoader": true,
      "p-a": true,
      "uploadLoader--starting": this.props.uploadState == "starting",
      "uploadLoader--progress": this.props.uploadState == "started",
      "uploadLoader--done": this.props.uploadState == "completed"
    });
    return classes;
  },
  render: function () {
    return (
      <div className={this.getLoaderClasses()}>
        <span className="uploadLoader-bar" style={this.getLoaderBarStyle()}>
          <span className="uploadLoader-animation"></span>
        </span>
      </div>
    );
  }
});

module.exports = UploadProgress;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/upload-progress.jsx